import React from 'react';
import { Link } from 'react-router-dom';
import { Star, Download, Edit } from 'lucide-react';

const ResourcesPanel: React.FC = () => {
  return (
    <div>
      {/* src/components/ResourcesPanel.tsx */}
      <div className="text-xs text-gray-400 mb-4">ResourcesPanel</div>
      
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Ressources</h2>
      
      <p className="text-gray-600 mb-8">
        Explorez nos ressources pour améliorer vos compétences en rédaction d'offres d'emploi.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Empty state when no featured resources */}
        <div className="col-span-full text-center py-8 bg-gray-50 rounded-lg border-2 border-dashed border-gray-200">
          <p className="text-gray-500">Aucune ressource mise en avant pour le moment</p>
        </div>
      </div>
    </div>
  );
};

export default ResourcesPanel;